import React from 'react';
import { Label, Input } from 'reactstrap';
import i18n from '../../../../../i18next';

import { negativeDecimalsValidation } from '../../../../../utils/CommonUtils';

const NutrientsListItem = props => {

    const { containerStyle, labelStyle, caloriesStyle } = styles;

    return (
        <div style={containerStyle}>
            <Label style={labelStyle}>
                {i18n.t(`common:nutritions.${props.nutrient.nutritionCode}`)}
                <div hidden={props.nutrient.nutritionCode !== 'cal'} style={caloriesStyle}>{`(${i18n.t('common:nutritions.kcal')})`}</div>:
            </Label>
            <Input
                type='number' name={props.nutrient.value}
                id={props.nutrient.id}
                // onChange={(e) => props.changeNutrientsState(e, props.nutrient)}
                onChange={(e) => props.changeNutrients(e, props.nutrient)}
                min={0}
                onKeyPress={(e) => negativeDecimalsValidation(e)}
                value={props.checkNutriValue(props.nutrient)}
            />
        </div>
    );

}

export default NutrientsListItem;

const styles = {
    containerStyle: {
        display: 'flex',
        flexFlow: 'direction row',
        paddingBottom: 12,
        marginBottom: 0
    },
    labelStyle: {
        alignSelf: 'center',
        display: 'flex',
        justifyContent: 'flex-start',
        width: '90%',
        whiteSpace: 'normal'
    },
    caloriesStyle: {
        display: 'flex',
        alignSelf: 'flex-end',
        fontSize: 12,
        marginBottom: 1,
        paddingLeft: 2
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/nutrients/NutrientsListItem.js